import { render } from "./Packs.vue?vue&type=template&id=0db44907"
import script from "./Packs.vue?vue&type=script&lang=js"
export * from "./Packs.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__